/**
 * AP-37 — **stufenweises Auf- und Zuklappen** der Gruppen in der Positionsübersicht.
 *
 * Ein Klick bewegt genau eine Ebene: Aufklappen öffnet die oberste Ebene, auf der
 * noch eine sichtbare Gruppe zu ist, und hält alles Tiefere geschlossen — sonst
 * gingen mit einem Klick zwei Ebenen auf. Zuklappen schließt die tiefste Ebene,
 * auf der noch eine sichtbare Gruppe offen ist.
 *
 * Gerechnet wird mit dem, was zu sehen ist: Eine offene Gruppe unter einer
 * geschlossenen zählt nicht, der Klick bliebe sonst ohne Wirkung.
 * `null` heißt: In diese Richtung gibt es keine Stufe mehr.
 */
export interface KlappGruppe {
  id: string
  parentId: string | null
  level: number
}

function sichtbare(gruppen: KlappGruppe[], zu: ReadonlySet<string>): KlappGruppe[] {
  const nachId = new Map(gruppen.map((g) => [g.id, g]))
  return gruppen.filter((g) => {
    for (let eltern = g.parentId; eltern; eltern = nachId.get(eltern)?.parentId ?? null) {
      if (zu.has(eltern)) return false
    }
    return true
  })
}

export function naechsteStufeAuf(gruppen: KlappGruppe[], zu: ReadonlySet<string>): Set<string> | null {
  const geschlossen = sichtbare(gruppen, zu).filter((g) => zu.has(g.id))
  if (geschlossen.length === 0) return null
  const ebene = Math.min(...geschlossen.map((g) => g.level))
  return new Set(gruppen.filter((g) => g.level > ebene || (g.level < ebene && zu.has(g.id))).map((g) => g.id))
}

export function naechsteStufeZu(gruppen: KlappGruppe[], zu: ReadonlySet<string>): Set<string> | null {
  const offen = sichtbare(gruppen, zu).filter((g) => !zu.has(g.id))
  if (offen.length === 0) return null
  const ebene = Math.max(...offen.map((g) => g.level))
  return new Set(gruppen.filter((g) => g.level >= ebene || zu.has(g.id)).map((g) => g.id))
}
